module.exports = __webpack_public_path__ + "static/media/calvin.3a568f8e.png";